import { useState } from "react";
import { Typography, IconButton, Paper, Divider, Input } from "../../tailwindcomponents";
import { CommentsObj } from "../../types/messages"
import { Add, Check, Close, CloseOutlined, Edit } from '../icons';
type MessagesProps = {
    onAddComment: Function,
    onDelete: Function,
    allComments: Array<CommentsObj>
    isEditMode: Boolean
    onEdit: Function
}

const Messages = ({ onAddComment, onDelete, allComments, isEditMode, onEdit }: MessagesProps) => {
    const [addComment, setAddComment] = useState(false)
    const [message, setMessage] = useState("")

    return (
        <div className="w-full flex justify-center">
            <div className="w-full max-h-[40vh] overflow-y-auto" >
                <div className="w-full p-4">
                    {isEditMode && <div>
                        {!addComment
                            ?
                            <div className="w-full mt-4" >
                                <IconButton color="info" onClick={() => setAddComment(true)}>
                                    <Add />
                                </IconButton>
                                <Divider light />
                            </div>
                            :
                            <div className="w-full mt-4" >
                                <div className="w-full flex self-center pb-4">
                                    <div className="w-5/6 p-2">
                                        <Paper variant="outlined">
                                            <div className="w-full self-center p-2">
                                                <Input
                                                    required
                                                    multiline={false}
                                                    label_text={"Insert Comment"}
                                                    value={message}
                                                    help_text="comment"
                                                    onTextChange={(value: string) => setMessage(value)}
                                                    type="text"
                                                    width={100}
                                                />
                                            </div>
                                        </Paper>
                                    </div>
                                    <div className="self-center">
                                        <div>
                                            <IconButton color="success" onClick={() => { onAddComment(message); setMessage("") }}>
                                                <Check />
                                            </IconButton>
                                            <IconButton color="error" onClick={() => { setAddComment(false); setMessage("") }}>
                                                <CloseOutlined />
                                            </IconButton>
                                        </div>
                                    </div>
                                </div>
                                <Divider light />
                            </div>
                        }
                    </div>}
                    {
                        allComments && allComments.map(el => {
                            return (
                                <div className="w-full mt-4" >
                                    <div className="w-full flex justify-between self-center pb-4">
                                        <Paper variant="outlined">
                                            <div className="flex justify-between self-center p-2">
                                                {!el.isEditing &&
                                                    <div className="self-center">
                                                        {(el.parent_id !== null && el.parent_id !== undefined) && <Typography text={"Edited"} fontWeight={"lighter"} variant="body2" />}
                                                        <Typography text={el.text} />
                                                    </div>
                                                }
                                                <div>
                                                    {
                                                        !el.is_system_generated && isEditMode &&
                                                        <div >
                                                            {el.isEditing ? (
                                                                <>
                                                                    <Input
                                                                        required
                                                                        multiline={false}
                                                                        label_text={"Edit Comment"}
                                                                        value={el.editText ?? el.text}
                                                                        help_text="comment"
                                                                        onTextChange={(value: string) => onEdit(el.comment_id, value)}
                                                                        type="text"
                                                                        width={100}
                                                                    />
                                                                    <IconButton color="success" onClick={() => onEdit(el.comment_id, el.editText ?? el.text, true)}>
                                                                        <Check />
                                                                    </IconButton>
                                                                    <IconButton color="error" onClick={() => onEdit(el.comment_id, el.text, false)}>
                                                                        <CloseOutlined />
                                                                    </IconButton>
                                                                </>
                                                                ) : (
                                                                    <div>
                                                                        <IconButton onClick={() => onEdit(el.comment_id)}>
                                                                            <Edit color="info" />
                                                                        </IconButton>
                                                                        <IconButton onClick={() => onDelete(el.comment_id)}>
                                                                            <Close color="error" />
                                                                        </IconButton>
                                                                    </div>
                                                            )}
                                                        </div>
                                                    }
                                                </div>
                                            </div>
                                        </Paper>
                                        <div className="ml-4">
                                            <div className="w-full">
                                                <Typography text={el.created_date_text} variant="caption" />
                                            </div>
                                            <div className="w-full">
                                                <Typography text={el.created_by_employee_name} variant="caption" />
                                            </div>
                                        </div>
                                    </div>
                                    <Divider light />
                                </div>
                            )
                        })
                    }
                </div>
            </div>
        </div>
    )
}

export default Messages;